<template>
  <div class="bq-solutions-qmjk">
    <div class="bq-solutions-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-solutions-title-wrap" :class="animateTitle">
          <div
            class="bq-solutions-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div
            class="bq-solutions-title-line"
            :style="{ backgroundImage: `url(${titleline})` }"
          ></div>
          <div class="bq-solutions-subtitle">
            健康医疗数据中心/便民惠民应用/智慧临床应用/监管运营应用
          </div>
        </div>
      </div>
    </div>
    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <!-- 健康医疗数据中心 -->
      <div class="bq-solution-item" :slot="tabs[0].slot">
        <SectionTitle :title="'全民健康信息平台总体架构'"></SectionTitle>
        <p class="tl">
          基于医院数据中心清洗、标化过的高质量数据，结合知识图谱、NLP技术和深度学习算法搭建临床所需的上层应用,包括智能临床辅助、病历质控、患者
          360、电子用药记录、闭环管理等
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1YnIZCVT7gK0jSZFpXXaTkpXa-1066-1020.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'健康医疗数据中心'"></SectionTitle>
        <div class="bq-item-title pl10">统一存储 长期保留</div>
        <div>
          <img
            class="w100p"
            src="https://img.alicdn.com/tfs/TB1Yjg0C.H1gK0jSZSyXXXtlpXa-1920-734.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'平台支撑主要模块'"></SectionTitle>
        <p class="tl">
          统一数据管理、居民索引、对外服务、业务监控、权限登录体系
        </p>
        <div
          :class="['modules-list', item.title]"
          v-for="item in modulelist"
          :key="item.title"
        >
          <div class="item-module tl" v-for="val in item.list" :key="val.title">
            <div>
              <img
                :src="val.icon"
                alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
              />
            </div>
            <div class="item-module-title">{{ val.title }}</div>
            <div class="item-module-desc">{{ val.desc }}</div>
          </div>
        </div>
        <SectionTitle :title="'算法中台'"></SectionTitle>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1k7.0C1T2gK0jSZFvXXXnFXXa-1026-572.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <!-- 智慧临床应用 -->
      <div class="bq-solution-item" :slot="tabs[1].slot">
        <SectionTitle :title="tabs[1].title"></SectionTitle>
        <p class="tl">
          搭建区域健康服务门户，覆盖诊前、诊中、诊后就诊全流程，同时基于海量文献知识库及算法模型，通过各类惠民应用，为居民提供全生命周期的精准
          个性化健康服务，有效提升就诊体验及满意度，提升区域的智慧服务能力。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB14nJaDbr1gK0jSZFDXXb9yVXa-1089-754.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1HJ4cDkY2gK0jSZFgXXc5OFXa-1008-272.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'区域互联网医院平台'"></SectionTitle>
        <p class="tl">
          搭建区域统一互联网医院平台，接入区域内二三级及基层医疗机构，为区域内的居民提供线上诊疗服务。基于基层医疗机构，可提供慢病续方、康复指
          导、诊后随访、健康宣教等服务。同时与院内药房及社会药房进行对接，实现处方流转、药品流通及线上配送业务闭环。基于统一平台优势，支持卫健
          等政府部门进行统一监管。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1S2dfDeH2gK0jSZJnXXaT1FXa-1008-910.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <!-- 智慧临床应用 -->
      <div class="bq-solution-item" :slot="tabs[2].slot">
        <SectionTitle :title="tabs[2].title"></SectionTitle>
        <p class="tl">
          居民健康全息视图是基于全民健康信息服务平台之上，打通居民全周期医疗卫生健康数据，为医护人员提供协同统一的电子健康记录互通调阅服务，为
          居民提供全生命周期医疗卫生记录。同时利用大数据分析技术和NLP、医疗知识图谱，辅助医护人员从各类医疗数据中快速定位、获取各场景下的重点
          信息，高效合理的诊治患者，为居民提供相应的医疗及健康服务，提升居民自我健康管理意识
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1MW1qGeH2gK0jSZJnXXaT1FXa-973-771.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <!-- 监管运营应用 -->
      <div class="bq-solution-item" :slot="tabs[3].slot">
        <SectionTitle :title="tabs[3].title"></SectionTitle>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1x8teDbH1gK0jSZFwXXc7aXXa-878-856.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
    </BqTab>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'qmjk',

  data() {
    return {
      animateTitle: [],
      titleline:
        'https://img.alicdn.com/tfs/TB1WhI3C7L0gK0jSZFxXXXWHVXa-900-17.png',
      titlebg:
        'https://img.alicdn.com/tfs/TB1rTnHFQL0gK0jSZFtXXXQCXXa-593-47.png',
      cover:
        'https://img.alicdn.com/tfs/TB1gAarEVP7gK0jSZFjXXc5aXXa-1920-380.png',
      activeIndex: parseInt(this.$route.query.tab || '0'),
      tabs: [
        {
          title: '健康医疗数据中心',
          slot: 'datacenter',
        },
        {
          title: '便民惠民应用',
          slot: 'wise',
        },
        {
          title: '智慧临床应用',
          slot: 'clinical',
        },
        {
          title: '监管运营应用',
          slot: 'manage',
        },
      ],
      modulelist: [
        {
          title: 'top',
          list: [
            {
              title: '主数据管理平台',
              desc: '为基础主数据建立规范的数据应用标准，提供数据标准映射功能',
              icon:
                'https://img.alicdn.com/tfs/TB1IWs5CYY1gK0jSZTEXXXDQVXa-85-92.png',
            },
            {
              title: '业务监控平台',
              desc:
                '开箱即用的一站式监控方案，包括IT设施基础监控，基于事件、自定义指标、日志的业务监控',
              icon:
                'https://img.alicdn.com/tfs/TB1qIk1C.T1gK0jSZFrXXcNCXXa-85-94.png',
            },
            {
              title: '索引管理平台',
              desc:
                '建立一人一码，形成个人唯一标识，促进系统互联互通，是形成个人完整档案的基础',
              icon:
                'https://img.alicdn.com/tfs/TB19Y.2C7L0gK0jSZFAXXcA9pXa-84-93.png',
            },
          ],
        },
        {
          title: 'bot',
          list: [
            {
              title: '数据质量管理平台',
              desc:
                '提升数据的完整性、规范性、及时性、一致性等，降低数据管理成本，提高数据利用率',
              icon:
                'https://img.alicdn.com/tfs/TB19GZ6CW61gK0jSZFlXXXDKFXa-83-99.png',
            },
            {
              title: '交互服务管理平台',
              desc:
                '将独立允许的服务进行统一的接入、管理、调度，实现异构服务间集成与管理',
              icon:
                'https://img.alicdn.com/tfs/TB1xQw0CVP7gK0jSZFjXXc5aXXa-80-99.png',
            },
            {
              title: '单点登录及权限管理平台',
              desc:
                '提供统一登录，解决不同应用间的重复登录；提供系统及应用的各项权限管理',
              icon:
                'https://img.alicdn.com/tfs/TB1kTAZCVT7gK0jSZFpXXaTkpXa-75-103.png',
            },
          ],
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  components: {
    BqTab,
    SectionTitle,
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-solutions-qmjk {
  .tl {
    text-align: left !important;
  }

  .pl10 {
    padding-left: 10px;
  }

  .ml35 {
    margin-left: 35px;
  }

  .mr35 {
    margin-right: 35px;
  }

  .mr15 {
    margin-right: 15px;
  }

  .ml15 {
    margin-left: 15px;
  }

  .mr80 {
    margin-right: 80px;
  }

  .ml80 {
    margin-left: 80px;
  }

  .ml124 {
    margin-left: 124px;
  }

  .mr124 {
    margin-right: 124px;
  }

  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .w100p {
    width: 100%;
  }

  .bq-solutions-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;

      .bq-solutions-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 117px;
        // right: 360px;
        right: 42%;
        transform: translateX(50%);

        &.animate-title {
          .bq-solutions-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 500%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-solutions-title-line,
          .bq-solutions-subtitle {
            transform: translate3d(0, 0, 0);
            opacity: 1;

            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-solutions-title {
        // opacity: 0;
        width: 668px;
        height: 53px;
        margin: 0 auto;
        margin-bottom: 31px;
        background-repeat: no-repeat;
      }
      .bq-solutions-title-line {
        opacity: 0;
        width: 900px;
        height: 17px;
        margin-bottom: 40px;
      }
      .bq-solutions-subtitle {
        opacity: 0;
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        letter-spacing: 10px;
      }
    }
  }

  .bq-solution-item {
    text-align: center;
    p {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      color: #333;
      font-size: 18px;
      margin-bottom: 60px;
    }

    & > div {
      margin-bottom: 60px;
    }

    .bq-solution-tag {
      margin: 0 auto;
      width: 363px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      font-size: 18px;
      background: rgba(32, 93, 171, 1);
      border-radius: 6px;
      cursor: default;
    }

    .bq-item-title {
      margin-top: 60px;
      margin-bottom: 0;
      color: #205dab;
      font-size: 24px;
    }

    .bq-imgbox-wrap {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .bq-imgtext-box {
        position: relative;
        .bq-img-text {
          position: absolute;
          bottom: 88px;
          left: 40px;
          right: 40px;
          text-align: left;
          font-size: 16px;
          color: #333;
        }
      }
    }

    .modules-list {
      width: 1200px;
      margin: 0 auto;
      display: flex;

      &.top {
        margin-bottom: 60px;
      }

      .item-module {
        width: 324px;

        &:nth-child(2) {
          margin: 0 131px 0 131px;
        }

        .item-module-title {
          color: #3b60a3;
          font-size: 20px;
          padding: 30px 0 20px;
        }

        .item-module-desc {
          color: #333;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
